// extracted by mini-css-extract-plugin
module.exports = {"faq-icon":"_02712f2b3b--faq-icon--pN1rz","tooltip":"_02712f2b3b--tooltip--gS7mP"};